import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import type {
  CompletedRefundTransaction,
  FailedRefundTransaction,
} from '~/api/graphql/generated/types'
import arrowImage from '~/components/common/images/arrowPaymentRequest.svg'
import catLaptopImage from '~/components/common/images/catLaptopPaymentRequest.svg'
import dogTerminalImage from '~/components/common/images/dogTerminalPaymentRequest.svg'
import { usePaymentTransactionStatus } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/hooks/usePaymentTransactionStatus'

import { useRefundDialog } from '../context/RefundDialogProvider'
import {
  isRefundTransactionCompleted,
  isRefundTransactionError,
} from '../utils/refundTransactionUtils'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './RefundProcessingScreen.module.scss'

export const RefundProcessingScreen = () => {
  const { t } = useTranslation('Dialogs')
  const { dialogState, actions } = useRefundDialog()
  const {
    refundAmount,
    selectedPaymentTerminal,
    selectedPaymentTerminalDisplayName,
    transactionId,
  } = dialogState
  const selectedTerminal =
    selectedPaymentTerminalDisplayName || selectedPaymentTerminal || ''
  const { transaction, error } = usePaymentTransactionStatus(
    transactionId || '',
  )

  useEffect(() => {
    if (transactionId && transaction) {
      if (isRefundTransactionCompleted(transaction)) {
        actions.handleRefundTransactionSuccess(
          dialogState,
          transaction as CompletedRefundTransaction,
        )
      } else if (isRefundTransactionError(transaction)) {
        actions.handleRefundTransactionFailure(
          dialogState,
          transaction as FailedRefundTransaction,
        )
      }
    } else if (transactionId && error) {
      actions.handleRefundTransactionHardFailure(dialogState)
    }
  }, [transactionId, transaction, error, actions, dialogState])

  return (
    <KibContainer className={styles.refundProcessingContainer}>
      <div className={styles.refundProcessingInfo}>
        <div className={styles.infoText}>
          {t('Dialogs:REFUND_DIALOG_V2.REFUND_PROCESSING_INFO', {
            amount: `${NumberUtils.formatMoney(refundAmount)}`,
            terminal: selectedTerminal,
          })}
        </div>
        <div className={styles.instructionText}>
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.LOOK_FOR_TRANSACTION_ON_TERMINAL')}
        </div>
      </div>
      <div className={styles.refundProcessingImages}>
        <img
          alt="Cat with Laptop"
          className={styles.refundImage}
          src={catLaptopImage}
        />
        <img alt="Arrow" className={styles.arrowImage} src={arrowImage} />
        <img
          alt="Dog with Terminal"
          className={styles.refundImage}
          src={dogTerminalImage}
        />
      </div>
    </KibContainer>
  )
}
